<template>
    <div class='order-form-list'>
        <div class="filter-wrapper">
            <date-picker v-model="datePickerValue" @change="datePickerChange"/>
            <my-search :styleData="{
                    placeholder: '输入订单号/会员手机号',
                    width: '248px',
                    height: '36px'
                }"
                :limitReg="computedInputNumberLimitReg"
                @searchData="searchData"/>
        </div>
        <!-- table -->
        <el-table v-loading="isLoading"
            v-textHighlight="{
                keyword: oKeyword,
                indexs: [2],
                isBegin: !isLoading
            }"
            ref="elTable"
            :data="tableData"
            :height="'calc(100vh - 145px)'"
            :empty-text="isLoading ? ' ' : '暂无数据'">
            <el-table-column type="index" label="#" />
            <el-table-column
                label="时间"
                prop="time"
                width="120"
                sortable>
                <template v-slot="{ row }">
                    <p>{{ getTime(row.create_time).y_m_d }}</p>
                    <p>{{ getTime(row.create_time).h_m_s }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="订单编号"
                min-width="180">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ get(row, 'order_no') }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="件数(件)"
                min-width="80"
                align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ get(row, 'goods_list.length') }}</span>
                </template>
            </el-table-column> -->
            <el-table-column
                label="商品总价(元)"
                min-width="120"
                align="right">
                <template v-slot="{ row }">
                    <span v-if="row.payment_method === 1"
                        class="text-popper"
                        v-textPopper
                        v-numberAlign>{{ get(row, 'subtotal') }}</span>
                    <span v-else>-</span> 
                </template>
            </el-table-column>
            <el-table-column
                label="总优惠(元)"
                min-width="120"
                align="right">
                <template v-slot="{ row }">
                    <span v-if="row.payment_method === 1"
                        class="text-popper" v-textPopper v-numberAlign>{{ getSum(get(row, 'member_discount_amount'), get(row, 'deal.discount_amount'), get(row, 'deal.round_down_amount'), getUserPoints(row.points) ? getUserPoints(row.points).amount_deducted : 0 ) }}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column
                label="实付金额(元)"
                min-width="120"
                align="right">
                <template v-slot="{ row }">
                    <p class="should-pay text-popper" v-textPopper v-numberAlign>{{ fixNum(get(row, 'actual_payment')) }}</p>
                    <p class="should-pay danger" v-if="hasRefundAll(row)">(已全额退款)</p>
                </template>
            </el-table-column>
            <el-table-column 
                align="right"
                min-width="140">
                <template v-slot:header="{ row }">
                    <table-filter-payment :items="paymentTypes" @confirm="filterPaymentConfirm" />
                </template>
                <template v-slot="{ row }">
                    <p>{{ getPaymentsText(row.payments) }}</p>
                </template>
            </el-table-column>
            <el-table-column min-width="10"/>
            <el-table-column
                label="收银员"
                min-width="160">
                <template v-slot="{ row }">
                    <user-info :userInfo="getUserInfo(row)"/>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="80">
                <template v-slot="scope">
                    <button class="text-btn first" @click="openDetail(scope)">详情</button>
                    <!-- <button class="text-btn success" v-if="hasRefundAll(row)">已全额退款</button> -->
                    <!-- <button class="text-btn danger" @click="refundMoney(row)" v-if="!hasRefundAll(row)">退款</button> -->
                </template>
            </el-table-column>
            <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && tableData.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
        <!-- component -->
        <order-form-detail :orderNo="orderNo" :visible.sync="isShowOrderFormDetail" @refund-success="refundSuccess"/>
    </div>
</template>

<script lang='tsx'>
import MySearch from '@/components/search/search.vue'
import DatePicker from '@/components/date_picker/date_picker.vue'
import OrderFormDetail from '../order_form_detail/order_form_detail.vue'
import { ref, Ref, createComponent, createElement, onBeforeMount, onMounted, SetupContext, computed } from '@vue/composition-api'
import { openMessage, useScrollLoad } from '@/utils/system.tsx'
import { getOneMonthValue, getSum } from '@/utils/index'
import { CreateElement } from 'vue/types/vue'
import $fetch from '../../../api'
import dayjs from 'dayjs'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { setObjectItemToFixed, fixNum, getPaymentsText } from '@/utils/index'
import TableFilterPayment from '@/components/table_filter_payment/table_filter_payment.vue'

/**
 *  deal_type {"0": "无减免", "1": "按比例打折", "2": "按金额减免", "3": "抹零"}
 */

export default createComponent({
    setup: (props: object, ctx: SetupContext) => {
        // reactive data
        const datePickerValue: Ref<any> = ref(getOneMonthValue())
        const isShowOrderFormDetail = ref(false)
        const orderNo: Ref<any> = ref<string>('')
        const paymentTypes = ref([])
        const tableData = ref([])
        const refundConfirmBtnText = ref('确认退款')
        const oKeyword = ref<string | undefined>()
        const isLoading = ref(false)
        const { page: oPage, isLoading: isScrollLoading, isHasMore, bindListener, initScrollLoad } = useScrollLoad()

        const store = ctx.root.$store

        // not reactive data and methods
        let index = 0
        let oLimit: number = 20
        let oStartDate: string = ''
        let oEndDate: string = ''
        let oPaymentList: number[] | undefined
        let oCustomPaymentIds: number[] | undefined

        const computedInputNumberLimitReg = computed(() => /^\d{0,19}$/)
        const format = (t?: string) => dayjs(t).format('YYYY-MM-DD')

        // 组件的入口
        onBeforeMount(() => {
            oLimit = 20
            oStartDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
            oEndDate = format()
            judgeParams()
            init()
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getOrderFormList
            })
        })

        const init = () => {
            isLoading.value = true
            Promise.all([
                getPaymentType(),
                getOrderFormList()
            ]).then(() => isLoading.value = false)
        }

        const judgeParams = () => {
            const params = ctx.root.$route.params
            console.log('params', params)
            if (params.start_date && params.end_date) {
                oStartDate = params.start_date
                oEndDate = params.end_date
                datePickerValue.value = [new Date(params.start_date), new Date(params.end_date)]
            }
        }

        // paymentType
        const getPaymentType = () => {
            return $fetch.post({
                url: '/shop/getconsumedpaymentconfig',
                params: {
                    start_date: oStartDate,
                    end_date: oEndDate,
                    // 0普通订单  1充值订单
                    order_type: 0
                }
            }).then(data => {
                console.log('支付方式信息', clone(data))
                paymentTypes.value = data
            }).catch(e => {
                openMessage('error', e.message || '获取支付方式失败')
            })
        }

        // 订单列表
        const getOrderFormList = (page: number = oPage.value, limit: number = oLimit, startDate: string = oStartDate, endDate: string = oEndDate, keyword: string | undefined = oKeyword.value, paymentList: number[] | undefined = oPaymentList, customPaymentIds: number[] | undefined = oCustomPaymentIds) => {
            const params: {
                page: number,
                limit: number,
                start_date: string,
                end_date: string,
                payment_list?: number[],
                custom_payment_ids?: number[],
                keyword?: string
            } = {
                page,
                limit,
                start_date: startDate,
                end_date: endDate,
                payment_list: paymentList,
                custom_payment_ids: customPaymentIds,
                keyword: oKeyword.value
            }
            return $fetch.post({
                url: '/order/orderdatalist',
                params
            }).then(data => {
                console.log('订单列表', clone(data.orders))
                data = setObjectItemToFixed(data, { ignore: ['discount_rate'] })
                if (page === 1) {
                    tableData.value = []
                    ctx.root.$nextTick(() => {
                        tableData.value = data.orders
                        initScrollLoad(data)
                    })
                } else {
                    tableData.value = tableData.value.concat(data.orders)
                }
                return data
            }).catch(e => openMessage('error', e.message || '获取订单列表失败'))
        }

        // 全额退款判断
        const hasRefundAll = (rowData) => {
            return rowData.refund_orders.length > 0
        }

        // 获取用户信息
        const getUserInfo = (rowData) => {
            const userInfo = get(rowData, 'creator.user')
            return Object.assign(userInfo, { gender: userInfo.gender })
        }

        // 搜索框搜索
        const searchData = (value: string, type: string) => {
            console.log(type, value)
            oKeyword.value = value ? value : undefined
            oPage.value = 1
            isLoading.value = true
            getOrderFormList()
                .then(() => isLoading.value = false)
        }

        // date picker change事件
        const datePickerChange = () => {
            oPage.value = 1
            if (datePickerValue.value === null) {
                // 清空的情况
                oStartDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
                oEndDate = format()
            } else {
                oStartDate = format(datePickerValue.value[0])
                oEndDate = format(datePickerValue.value[1])
            }
            init()
        }

        // 将时间分成两部分
        const getTime = (t: string) => {
            if (!t) { return {} }
            const arr = t.split(' ')
            return {
                y_m_d: arr[0],
                h_m_s: arr[1]
            }
        }

        // 详情
        const openDetail = (scope: any) => {
            index = scope.$index
            orderNo.value = scope.row.order_no
            isShowOrderFormDetail.value = true
        }

        const refundSuccess = () => {
            isLoading.value = true
            oPage.value = refreshNum() + 1
            tableData.value = tableData.value.slice(0, refreshNum() * oLimit)
            getOrderFormList()
                .then(() => isLoading.value = false)
        }

        const refreshNum = () => {
            const i = Math.floor((index + 1) / oLimit)

            return i
        }

        const filterPaymentConfirm = (val) => {
            oPaymentList = val.paymentList
            oCustomPaymentIds = val.customPaymentIds
            oPage.value = 1
            isLoading.value = true
            getOrderFormList()
                .then(() => isLoading.value = false)
        }

        const getUserPoints = (points) => {
            if (points == null) {
                return
            }
            return points.find(p => p.points_type === 1)
        }

        return {
            // data
            isShowOrderFormDetail,
            paymentTypes,
            orderNo,
            datePickerValue,
            tableData,
            isLoading,
            isScrollLoading,
            isHasMore,
            oKeyword,
            computedInputNumberLimitReg,
            // methods
            get,
            getTime,
            hasRefundAll,
            getUserInfo,
            searchData,
            datePickerChange,
            openDetail,
            getPaymentsText,
            fixNum,
            getSum,
            filterPaymentConfirm,
            refundSuccess,
            getUserPoints
        }
    },
    components: {
        DatePicker,
        MySearch,
        OrderFormDetail,
        TableFilterPayment
    }
})
</script>

<style lang="scss" scoped>
::v-deep .ascending  .ascending.sort-caret {
    border-bottom-color: #333 !important;
}

::v-deep .descending  .descending.sort-caret { 
    border-top-color: #333 !important;
}

.order-form-list {
    position: relative;

    .filter-wrapper {
        position: absolute;
        right: 0;
        top: -54px;
        display: inline-flex;
        align-items: center;
    }

    .should-pay {
        line-height: 1;
    
        &.danger {
            font-size: 12px;
            color: #E51C23;
        }
    }

    .text-btn.first {
        padding-left: 0;
    }

    .text-btn.success {
        color: #009688;
        cursor: default;

        &:active {
            transform: scale(1);
        }
    }
}
</style>